<template>
  <article class="product-next">
    <div class="product-next-container">
      <div v-if="product.nextProductImage" class="product-next-image">
        <WidgetPicture
          class="is-cover"
          :image="{ custom: product.nextProductImage.responsiveImage }"
          :alt="product.name"
        />
      </div>
      <div v-else class="product-next-image-placeholder"></div>

      <div class="product-next-text">
        <div v-if="product.productPretitle" class="product-next-pretitle is-text-uppercase" v-html="product.productPretitle" />
        <div v-if="product.name" class="product-next-title title-l-1 is-text-uppercase">
          {{ product.name }}
        </div>
        <div v-if="product.slug" class="product-next-link">
          <WidgetArrowLink
            :label="$t('cta.discover')"
            :link="
              localePath({
                name: 'product-slug',
                params: { slug: product.slug },
              })
            "
          />
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PagesProductNextProduct',
}
</script>

<script setup>
const props = defineProps({
  product: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<style lang="scss">
@import './style.scss';
</style>
